"use client";

import Link from "next/link";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";

export default function SocialLinks() {
  return (
    <div className="bg-card rounded-xl p-6 shadow-sm border border-border">
      <h3 className="text-lg font-semibold mb-4 text-foreground">Follow Us</h3>
      <div className="grid grid-cols-2 gap-3">
        <Link
          href="https://www.facebook.com/LJP4India/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 p-3 rounded-lg bg-blue-50 hover:bg-blue-100 transition-colors border border-blue-100"
        >
          <FaFacebookF className="w-4 h-4 text-blue-600" />
          <span className="text-xs font-medium text-blue-600">Facebook</span>
        </Link>
        <Link
          href="https://www.instagram.com/ljp.india/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 p-3 rounded-lg bg-pink-50 hover:bg-pink-100 transition-colors border border-pink-100"
        >
          <FaInstagram className="w-4 h-4 text-pink-600" />
          <span className="text-xs font-medium text-pink-600">Instagram</span>
        </Link>

        <Link
          href="https://www.youtube.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 p-3 rounded-lg bg-red-50 hover:bg-red-100 transition-colors border border-red-100 col-span-2"
        >
          <FaYoutube className="w-4 h-4 text-red-600" />
          <span className="text-xs font-medium text-red-600">YouTube</span>
        </Link>
      </div>
    </div>
  );
}
